import React, {useState} from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import Select from 'react-select'
import { makeStyles } from '@material-ui/core/styles';
import makeAnimated from 'react-select/animated';
import history from '../../history';

const animatedComponents = makeAnimated();

// <div className="col-lg-4 asp-item">
//   <Select
//     closeMenuOnSelect={false}
//     components={animatedComponents}
//     isMulti
//     options={options1}
//   />
// </div>

const AdvancedSearch = ({searchColor, cities, categories, filters, setFilters, searchWithFilters}) => {

  const [selectedValue, setSelectedValue] = useState('');
  const [checked, setChecked] = React.useState(false);

  const handleChangeCheckbox = (event) => {
    // setChecked(event.target.checked);
    setFilters({
      ...filters,
      'onlyOpen': event.target.checked
    });
  };

  const useStyles = makeStyles ( () => ({
    aspSquare: {
      backgroundColor: searchColor,
      margin: '5px',
      padding: '15px'
    },
    formControl: {
      width: '100%',
      margin: '7px 0px 1px 0px'
    }
  }));

  const handleChange = (e, name) => {
    setFilters({
      ...filters,
      [name]: e.value
    });
  };

  const submitForm = e => {
    e.preventDefault();

    let uri = "?city="+citiesFilter+"&category="+categoriesFilter+"&search="+searchFilter+"&onlyOpenStores="+(onlyOpen?"1":"0");

    history.push(process.env.REACT_APP_PREFIX_DIR + uri);

    searchWithFilters();
  }

  const {citiesFilter, categoriesFilter, onlyOpen, searchFilter} = filters;

  const classes = useStyles();

  return (
    <div className="container asp-container">
      {
          searchColor!=='' ?
          <div className={"row " + classes.aspSquare}>

            <form onSubmit={(e) => submitForm(e)} id="searchForm" className={"row " + classes.formControl}>
              <div className="col-lg-4 asp-item">
                <Select
                  options={cities}
                  onChange={(e)=>handleChange(e,'citiesFilter')}
                  placeholder="Seleccionar Ciudad"
                  />
              </div>

              <div className="col-lg-4 asp-item">
                <Select
                  options={categories}
                  onChange={(e)=>handleChange(e,'categoriesFilter')}
                  placeholder="Seleccionar Categoria"
                  />
              </div>

              <div className="col-lg-4 asp-item">
              <div className="row col-sm-12 col-md-12 col-lg-12 mx-0 px-0">
                <input
                  type="text"
                  className="form-control col-sm-11 col-md-11 col-lg-11 mb-2 asp-input-group"
                  placeholder="Búsqueda..."
                  onChange={(e)=>handleChange(e.target,'searchFilter')}
                  />
                <button
                  type="submit"
                  className="btn btn-secondary mb-2 col-sm-1 col-md-1 col-lg-1 bottonlarge">
                  <i className="fa fa-search" aria-hidden="true"></i>
                </button>
              </div>
              </div>

              <div className="col-lg-4 asp-item">
                <Checkbox
                  className="padding-top-1"
                  color="primary"
                  checked={onlyOpen}
                  onChange={handleChangeCheckbox}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
                <span className="span-soft-black">
                  Solo Tiendas Abiertas
                </span>
              </div>
            </form>
          </div>
          :
          null
      }
    </div>
  )
}

export default AdvancedSearch;
